<div class="property-information-container">
  <form #propertyInfoForm="ngForm" class="property-info-form">
    <div class="section-header mb-3">
      <h5>Property Information</h5>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Property Address</label>
        <text-input
          [(ngModel)]="formData.propertyAddress"
          name="propertyAddress"
          [readonly]="true">
        </text-input>
      </div>

      <div class="col-md-3 mb-3">
        <label class="form-label">City</label>
        <text-input
          [(ngModel)]="formData.city"
          name="city"
          [readonly]="true">
        </text-input>
      </div>

      <div class="col-md-1 mb-3">
        <label class="form-label">State</label>
        <select class="form-select"
          name="state"
          [(ngModel)]="formData.state"
          [disabled]="true">
          <option value="">-- Select State --</option>
          @for (state of states; track state.value) {
            <option [value]="state.value">
              {{ state.name }}
            </option>
          }
        </select>
      </div>

      <div class="col-md-2 mb-3">
        <label class="form-label">Zip</label>
        <text-input
          [(ngModel)]="formData.zip"
          name="zip"
          [readonly]="true">
        </text-input>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <label class="form-label">MERS MIN</label>
        <text-input
          [(ngModel)]="formData.mersMin"
          name="mersMin"
          [readonly]="true">
        </text-input>
      </div>

      <div class="col-md-6">
        <label class="form-label">Property Type</label>
        <text-input
          [(ngModel)]="formData.propertyType"
          name="propertyType"
          [readonly]="true">
        </text-input>
      </div>
    </div>

    <div class="section-header mb-3 mt-4">
      <h5>Title Information</h5>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Title Held In<span class="text-danger">*</span></label>
        <select
          class="form-select"
          [(ngModel)]="formData.mannerTitleHeldAs"
          name="mannerTitleHeldAs"
          required>
          <option [ngValue]="null">-- Select --</option>
          @for (option of mannerTitleHeldAsOptions; track option.value) {
            <option [ngValue]="option.value">
              {{ option.label }}
            </option>
          }
        </select>
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Vesting</label>
        <text-input
          [(ngModel)]="formData.vesting"
          name="vesting">
        </text-input>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Will a POA be used?</label>
        <select
          class="form-select"
          [(ngModel)]="formData.willPoaBeUsed"
          name="willPoaBeUsed">
          @for (option of yesNoOptions; track option.label) {
            <option [ngValue]="option.value">
              {{ option.label }}
            </option>
          }
        </select>
        <small class="text-info d-block mt-1">
          <i class="fa-solid fa-info-circle"></i>
          If yes, please upload "Legal: Power of Attorney" to loan docs for review &amp; approval
        </small>
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Will this loan close in a trust?</label>
        <select
          class="form-select"
          [(ngModel)]="formData.willLoanCloseInTrust"
          name="willLoanCloseInTrust">
          @for (option of yesNoOptions; track option.label) {
            <option [ngValue]="option.value">
              {{ option.label }}
            </option>
          }
        </select>
        <small class="text-info d-block mt-1">
          <i class="fa-solid fa-info-circle"></i>
          If yes, upload "Trust Agreement" to loan docs for review &amp; approval
        </small>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Will vesting be held in a LLC?</label>
        <select
          class="form-select"
          [(ngModel)]="formData.isLlc"
          name="isLlc">
          @for (option of yesNoOptions; track option.label) {
            <option [ngValue]="option.value">
              {{ option.label }}
            </option>
          }
        </select>
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Non-Borrower Title Holder</label>
        <select
          class="form-select"
          [(ngModel)]="formData.nonBorrowerTitleHolder"
          name="nonBorrowerTitleHolder">
          @for (option of yesNoOptions; track option.label) {
            <option [ngValue]="option.value">
              {{ option.label }}
            </option>
          }
        </select>
      </div>
    </div>

    @if (showConditionalFields) {
      <div class="conditional-fields">
        <div class="section-header mb-3">
          <h5>Non-Borrower Title Holder Information</h5>
        </div>

        <div class="row">
          <div class="col-md-4 mb-3">
            <label class="form-label">Name <span class="text-danger">*</span></label>
            <text-input
              [(ngModel)]="formData.nonBorrowerName"
              name="nonBorrowerName"
              [required]="true">
            </text-input>
          </div>
          <div class="col-md-4 mb-3">
            <label class="form-label">Phone <span class="text-danger">*</span></label>
            <text-input
              [(ngModel)]="formData.nonBorrowerPhone"
              name="nonBorrowerPhone"
              [required]="true">
            </text-input>
          </div>
          <div class="col-md-4 mb-3">
            <label class="form-label">Email <span class="text-danger">*</span></label>
            <text-input
              [(ngModel)]="formData.nonBorrowerEmail"
              name="nonBorrowerEmail"
              [required]="true">
            </text-input>
          </div>
        </div>
      </div>
    }
  </form>
</div>
